module.exports = __webpack_public_path__ + "static/media/b7.6968050.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dili/b7.mp3
// module id = uH4T
// module chunks = 0